module.exports = __webpack_public_path__ + "img/case-logo-14.e61705ea.png";